export class ContactUsModel {
  constructor(emailIn: string, nameIn: string, messageIn: string, typeIn: number) {
    this.email = emailIn;
    this.name = nameIn;
    this.message = messageIn;
    this.typeOfInquiry = typeIn;
  }
  public name: string;
  public email: string;
  public message: string;
  public typeOfInquiry: number;
}
